var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner mx-auto",
    staticStyle: {
      "max-width": "948px"
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("상품권 교환소")]), _c('div', {
    staticClass: "mt-4px mt-lg-8px font-size-14 font-size-md-16 grey--text text--garken-3"
  }, [_vm._v(" 교환권번호를 입력하여 나누리 캐시로 교환하실 수 있습니다. ")])]), _c('v-row', {
    staticClass: "ma-n4"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-col', _vm._b({
      key: item.value,
      staticClass: "pa-4",
      attrs: {
        "cols": "12"
      }
    }, 'v-col', {
      lg: _vm.lg
    }, false), [_c('v-card', _vm._b({
      staticStyle: {
        "overflow": "visible"
      },
      attrs: {
        "elevation": "0",
        "to": "/exchange/".concat(item.value.toLowerCase())
      }
    }, 'v-card', {
      disabled: item.disabled
    }, false), [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var hover = _ref.hover;
          return [_c('v-responsive', {
            staticStyle: {
              "overflow": "visible"
            },
            attrs: {
              "aspect-ratio": 3 / 2
            }
          }, [_c('v-card', {
            staticClass: "fill-height",
            staticStyle: {
              "position": "relative"
            },
            attrs: {
              "rounded": "lg"
            }
          }, [_c('v-card-text', {
            staticClass: "fill-height d-flex justify-center align-center px-4 py-0"
          }, [_c('v-img', _vm._b({}, 'v-img', Object.assign({}, item.image, {
            contain: true
          }), false))], 1), _c('v-fade-transition', [_c('v-overlay', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: hover,
              expression: "hover"
            }],
            staticClass: "exchange-list-item-card__overlay",
            attrs: {
              "absolute": "",
              "color": "primary",
              "opacity": "0.05"
            }
          }, [_c('v-slide-x-transition', [_c('v-card', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: hover,
              expression: "hover"
            }],
            staticClass: "rounded-b-lg",
            attrs: {
              "dark": "",
              "color": "primary",
              "elevation": "0"
            }
          }, [_c('v-card-actions', {
            staticClass: "d-flex justify-end align-baseline py-3 px-6",
            staticStyle: {
              "gap": "8px"
            }
          }, [_c('span', [_vm._v(" 교환하기 ")]), _c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-arrow-right")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)];
        }
      }], null, true)
    }), !_vm.$vuetify.breakpoint.mobile ? _c('v-card-text', {
      staticClass: "px-0 text-center"
    }, [_c('b', [_vm._v(_vm._s(item.text))]), _vm._v("에서 받은 교환번호를 "), _c('br'), _vm._v(" 나누리 상품권으로 교환하실 수 있습니다. ")]) : _vm._e(), _c('v-overlay', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.disabled,
        expression: "item.disabled"
      }],
      staticStyle: {
        "pointer-events": "none"
      },
      attrs: {
        "absolute": "",
        "light": "",
        "color": "white"
      }
    }, [_c('span', {
      staticClass: "tit--sm font-weight-black black--text"
    }, [_vm._v(" 준비중입니다. ")])])], 1)], 1)];
  })], 2)], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }